// Zentrale Kampagnen-Konfiguration — Marke, Texte, Zeiten und Gewinnstruktur hier anpassen.
export const CAMPAIGN = {
  brand: "ChickenWinner",
  domain: "chickenwinner.ch",
  campaignName: "CHICKENWINNER",
  slogan: "Winner winner, chicken dinner.",
  eyebrow: "CHICKENWINNER",
  trustLine: "Schweizer Wettbewerb · Kostenlos · Ab 18 Jahren",
  instagramUrl: "https://instagram.com/chickenwinner.ch",
  instagramHandle: "@chickenwinner.ch",
  tiktokUrl: "",
  contactEmail: "info@chickenwinner.ch", // PUBLIC_CONTACT_EMAIL
  ctaPrimary: "Jetzt kostenlos teilnehmen",
  launchIso: "2026-09-01T00:00:00+02:00", // Europe/Zurich (CEST)
  deadlineIso: "2026-10-07T23:59:59+02:00", // Europe/Zurich (CEST)
  launchLabel: "1. September 2026",
  deadlineLabel: "7. Oktober 2026, 23:59 Uhr",
  consentVersion: "cw-2026-09-v4",
  bonusName: "ChickenWinner Steuer-Sparpaket 2027",
  bonusBullets: ["23 Prüfpunkte", "Unterlagen-Checkliste", "5-Minuten-Steuercheck"],
};

export const PRIZE_LABELS = {
  tax2027: "Steuererklärung 2027 gratis",
  cash100: "CHF 100 Cash",
  main7years: "7 Jahre Steuererklärung gratis",
};

export const DRAW_SCHEDULE = [
  { date: "2026-09-14", label: "14. September 2026", at: "2026-09-14T12:00:00+02:00", prizes: [{ type: "tax2027", count: 4 }, { type: "cash100", count: 1 }] },
  { date: "2026-09-21", label: "21. September 2026", at: "2026-09-21T12:00:00+02:00", prizes: [{ type: "tax2027", count: 4 }, { type: "cash100", count: 1 }] },
  { date: "2026-09-28", label: "28. September 2026", at: "2026-09-28T12:00:00+02:00", prizes: [{ type: "tax2027", count: 4 }, { type: "cash100", count: 1 }] },
  { date: "2026-10-05", label: "5. Oktober 2026", at: "2026-10-05T12:00:00+02:00", prizes: [{ type: "tax2027", count: 4 }, { type: "cash100", count: 1 }] },
  { date: "2026-10-08", label: "8. Oktober 2026", at: "2026-10-08T12:00:00+02:00", prizes: [{ type: "tax2027", count: 4 }, { type: "cash100", count: 1 }, { type: "main7years", count: 1 }] },
];

export const getNextDraw = (now = Date.now()) =>
  DRAW_SCHEDULE.find((d) => new Date(d.at).getTime() > now) || null;

// Rechtliche Betreiber-Angaben
export const LEGAL = {
  entityName: "ChickenWinner.ch",
  address: "Zürich, Schweiz",
  email: "info@chickenwinner.ch",
};
